import swal from 'sweetalert';
import {
    formatError,
    runLogoutTimer,
    saveTokenInLocalStorage,
    signUp
} from '../../services/AuthService';
import { api } from '../../utils/api';
import { translate } from '../../utils/translate';

export const SIGNUP_CONFIRMED_ACTION = '[signup action] confirmed signup';
export const SIGNUP_FAILED_ACTION = '[signup action] failed signup';
export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';

export function signupAction(email, password, history) {
    return (dispatch) => {
        signUp(email, password)
            .then((response) => {
                saveTokenInLocalStorage(response.data);
                runLogoutTimer(
                    dispatch,
                    response.data.expiresIn * 1000,
                    history,
                );
                dispatch(confirmedSignupAction(response.data));
                history.push('/dashboard');
            })
            .catch((error) => {
                const errorMessage = formatError(error.response.data);
                dispatch(signupFailedAction(errorMessage));
            });
    };
}

export function logout(history, path) {
    history.push('/login');
    localStorage.removeItem('rsi-admin-crm');
    localStorage.removeItem('rsi-admin-timer');
    return {
        type: LOGOUT_ACTION,
    };
}

export function loginAction(inputData, history, lang) {
    return (dispatch) => {
        let data = {
            "username": inputData.username,
            "password": inputData.password,
        };
        fetch(api.login, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept-Language": lang.toLowerCase()
            }),
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then(responseJson => {
                if (responseJson.status === 'success') {
                    saveTokenInLocalStorage(responseJson.data, inputData.rememberMe);
                    dispatch(loadingToggleAction(false))
                    dispatch(loginConfirmedAction(responseJson.data));
                    history.push('/dashboard');
                } else {
                    swal(translate(lang, 'Error'), responseJson.message, "error");
                    const errorMessage = translate(lang, 'Invalid email or password');
                    dispatch(loginFailedAction(errorMessage));
                    dispatch(loadingToggleAction(false))
                }
            }).catch(error => {
                dispatch(loadingToggleAction(false))
                console.error("error", error);
            });

     
    };
}


export function loginFailedAction(data) {
    return {
        type: LOGIN_FAILED_ACTION,
        payload: data,
    };
}

export function loginConfirmedAction(data) {
    return {
        type: LOGIN_CONFIRMED_ACTION,
        payload: data,
    };
}

export function confirmedSignupAction(payload) {
    return {
        type: SIGNUP_CONFIRMED_ACTION,
        payload,
    };
}

export function signupFailedAction(message) {
    return {
        type: SIGNUP_FAILED_ACTION,
        payload: message,
    };
}

export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}
